export default "__VITE_ASSET__DXjDW8qb__"